import { DomainExtension } from '../enums/domain';

export const getTelegramLink = (
  userId: string,
  domainExtension: `${DomainExtension}`,
  currency: string,
) =>
  `${process.env.REACT_APP_TELEGRAM_URL}?start=${userId}_${domainExtension}_${currency.toLowerCase()}`;
